import ProjectDashboardsPage from './ProjectDashboardsPage';
export default ProjectDashboardsPage;